import { getFirebase } from "react-redux-firebase";
import { Action, ActionCreator, AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IAnnotation, IShapeData } from "../lib/react-picture-annotation";
import { Area, AreaStatus, ImageStatus } from "../models/Area";
import { Zone } from "../models/Zone";
import { getEditAreaDialogKey } from "../selectors/dialog.selector";
import { getProjectId } from "../selectors/project.selector";

export const EDIT_AREA_DIALOG_OPEN = 'EDIT_AREA_DIALOG_OPEN'
export const EDIT_AREA_DIALOG_CLOSED = 'EDIT_AREA_DIALOG_CLOSED'
export const  EDIT_AREA_DIALOG_ZONE_OPEN = ' EDIT_AREA_DIALOG_ZONE_OPEN'
export const EDIT_AREA_DIALOG_ZONE_CLOSED = 'EDIT_AREA_DIALOG_ZONE_CLOSED'

export interface EditAreaOpenAction extends Action {
    type: 'EDIT_AREA_DIALOG_OPEN'
    payload: {
        areaKey: string
    }
}


export interface EditAreaCloseAction extends Action {
    type: 'EDIT_AREA_DIALOG_CLOSED'
    payload: {
        
    }
}

export interface EditAreaZoneOpenAction extends Action {
    type: 'EDIT_AREA_DIALOG_ZONE_OPEN'
    payload: {
        areaKey: string
    }
}


export interface EditAreaZoneCloseAction extends Action {
    type: 'EDIT_AREA_DIALOG_ZONE_CLOSED'
    payload: {
        
    }
}

const openEditAreaDialog: ActionCreator<EditAreaOpenAction> = (areaKey: string) => ({
    type: EDIT_AREA_DIALOG_OPEN,
    payload: {
        areaKey
    }
})

const closedEditAreaDialog: ActionCreator<EditAreaCloseAction> = () => ({
    type: EDIT_AREA_DIALOG_CLOSED,
    payload: {
    
    }
})


const openEditAreaZoneDialog: ActionCreator<EditAreaZoneOpenAction> = (areaKey: string) => ({
    type: EDIT_AREA_DIALOG_ZONE_OPEN,
    payload: {
        areaKey
    }
})

const closedEditAreaZoneDialog: ActionCreator<EditAreaZoneCloseAction> = () => ({
    type: EDIT_AREA_DIALOG_ZONE_CLOSED,
    payload: {
    
    }
})



const uploadZones = (annotations: IAnnotation<IShapeData>[]) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        const state = getState()

        const projectId = getProjectId(state)
        const areaId =  getEditAreaDialogKey(state)

        const entityRoute = `/zones/projects/${projectId}/areas/${areaId}/zones/`;

 
        
        const updates: Record<string, Zone> = {}
        annotations.forEach(annotation => {
            
            updates[`${entityRoute}${annotation.id}`] = {
                name: !!annotation.comment ? annotation.comment: "",
                height: annotation.mark.height,
                width: annotation.mark.width,
                color: !!annotation.mark.strokeColor ? annotation.mark.strokeColor : "#000",
                x: annotation.mark.x,
                y: annotation.mark.y,
                page: !!annotation.page ? annotation.page : 1
                
            }
        })
        
        await firebase.database().ref().update(updates)
    }
}


const uploadArea = (file: File | Blob) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        const state = getState()

        const projectId = getProjectId(state)
        const newKey =   firebase.database().ref().push().key;

        const entityRoute = `/blueprints/projects/${projectId}/areas/${newKey}`;

        const area:Area = {
            name: 'BluePrint',
            status: AreaStatus.Processing,
            fileName: file.name,
            blueprintStatus: ImageStatus.Processing,
            thumbnailStatus: ImageStatus.Processing
        }
        
        try {
            await firebase.database().ref(`/blueprints/projects/${projectId}/areas/${newKey}`).update(area)


            const jobResult = await  firebase.uploadFile(`${entityRoute}`, file, null, {
                    
            })
            
            
            const updates = {} as Record<string, string>
            updates[`/blueprints/projects/${projectId}/areas/${newKey}/status`] = AreaStatus.Done
            await firebase.database().ref().update(updates)
        
            return {area, areaKey: newKey};  
        } catch(e) {
            const updates = {} as Record<string, string>

            updates[`/blueprints/projects/${projectId}/areas/${newKey}/status`] = AreaStatus.Error
            await firebase.database().ref().update(updates)

            throw e

        }  
    }
}

const changeArea = (name: string) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        const state = getState()
    
        const areaKey = getEditAreaDialogKey(state)

        const projectId = getProjectId(state)

        const updates = {} as Record<string, string>

        updates[`/blueprints/projects/${projectId}/areas/${areaKey}/name`] = name

        await firebase.database().ref(`/blueprints/projects/${projectId}/areas/${areaKey}`).update({
            name
        })
    }
}

const deleteAreaZone = (areaId: string) => {
    const firebase = getFirebase();
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        const state = getState()

        const projectId = getProjectId(state)


        await firebase.database().ref(`/blueprints/projects/${projectId}/areas/${areaId}`).remove()
    }
}



export const areaActions = {
    uploadArea,
    openEditAreaDialog,
    closedEditAreaDialog,
    changeArea,
    openEditAreaZoneDialog,
    closedEditAreaZoneDialog,
    uploadZones,
    deleteAreaZone
}


// WEBPACK FOOTER //
// ./src/actions/area.actions.ts